













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { messageType } from '@/interfaces/websocketMessageInterfaces';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import moment from 'moment';
import { getAttachmentInfo } from '@/apis/common';
import { UploadFileIF } from '@/interfaces/types';
import { ImagePreview } from 'vant';
import { constant, forEach } from 'lodash';
import { nextTick } from 'vue/types/umd';
import { PropType } from 'vue';
let AUDIOPLAY = false;

@Component({})
export default class ChatContent extends Vue {
  private messageType = messageType;
  @Prop() historyMessage!: any;
  private type = 'user';
  private moment = moment;
  private file: UploadFileIF = {
    fileid: '', // 文件id
    ext: '', // 文件类型图小
    ext_s: '', // 文件类型图大
    ext_type: '', // 后缀
    size: '', // 文件大小
    name: '', // 文件名称
    url: '', // 文件下载地址
    date: '',
    rurl: '', // 文件预览地址
    isPic: 0, // 1是
  };
  private msgObj: object = {};
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  viewImage(rul:string) {
    ImagePreview([rul]);
  }
  mounted() {
    const { historyMessage, userInfo } = this;
    if (userInfo.id == historyMessage.id) {
      this.type = 'user';
    } else {
      this.type = 'other';
    }
  }
  audioPlay() {
    let audio = this.$refs.audioFile as any;
    if (AUDIOPLAY) {
      AUDIOPLAY = false;
      audio.pause();
      audio.currentTime = 0
    } else {
      this.pauseAllAudio().then(()=>{
      audio.play();
      AUDIOPLAY = true;
      });
    }
  }
  async pauseAllAudio() : Promise<void> {
    let allAudio = document.getElementsByTagName('audio') as any;
    allAudio.forEach((item: any) => {
      console.log(item);
      item.pause();
      item.currentTime = 0
    });
    AUDIOPLAY = false;
  }
}
